import { supabase } from '@/integrations/supabase/client';

export interface GeocodeResult {
  lat: number;
  lng: number;
  formatted_address?: string;
}

/**
 * Geocodes an address string via the server-side `geocode-address` edge function.
 * Pass the tenant's ISO country code so the lookup is restricted to that
 * country (short addresses like "22 Pebble Beach Drive" exist on several
 * continents). Returns null on any failure — callers should treat geocoding as
 * best-effort; the DB trigger safety net will catch anything that falls through.
 */
export async function geocodeAddress(address: string, countryCode?: string): Promise<GeocodeResult | null> {
  const trimmed = address?.trim();
  if (!trimmed) return null;

  try {
    const { data, error } = await supabase.functions.invoke<GeocodeResult | { error: string }>(
      'geocode-address',
      { body: { address: trimmed, country: countryCode } }
    );

    if (error || !data || 'error' in data) {
      console.warn('Geocoding failed:', error ?? (data as { error: string })?.error);
      return null;
    }

    return data;
  } catch (err) {
    console.warn('Geocoding exception:', err);
    return null;
  }
}
